/**
 * This is a workaround for a bug which happens when Google Chrome translates the page and bumps into
 * the `<span>&#8203;</span>` generated by the MUI Input.
 * See also: https://leaseplan-digital.atlassian.net/browse/CJ4VS-933
 */
export const NO_TRANSLATE_CLASS_NAME = 'notranslate'
